import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

function Terminal({ available }) {
  return (
    <div className="hero-terminal">
      <div className="terminal-bar">
        <div className="terminal-dots">
          <span className="dot dot-red" />
          <span className="dot dot-yellow" />
          <span className="dot dot-green-mac" />
        </div>
        <span className="terminal-title">lino@dev:~</span>
      </div>
      <div className="terminal-body">
        <div className="t-line"><span className="t-prompt">$</span> <span className="t-cmd">projects --shipped</span></div>
        <div className="t-output">6 projects delivered</div>
        <div className="t-line t-mt"><span className="t-prompt">$</span> <span className="t-cmd">git log --oneline</span></div>
        <div className="t-output">a3f2b1 AutoRent Pro</div>
        <div className="t-output">b4d8c2 Discord Music Bot</div>
        <div className="t-output">c91fa3 Real Estate Scraper</div>
        <div className="t-line t-mt"><span className="t-prompt">$</span> <span className="t-cmd">cat status.txt</span></div>
        <div className="t-output t-available"><span className="t-dot" />{available}</div>
        <div className="t-line t-mt"><span className="t-prompt">$</span> <span className="t-cursor">▋</span></div>
      </div>
    </div>
  );
}

export default function About() {
  const { t } = useLanguage();

  return (
    <section id="about" className="about-v3">
      <div className="about-v3-inner">
        <motion.div
          className="about-v3-label"
          initial={{ opacity: 0, x: -16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="about-v3-num">02</span>
          <div className="section-tag" style={{ marginBottom: 0 }}>{t('nav.about')}</div>
        </motion.div>

        <motion.div
          className="about-v3-content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <h2>{t('about.title')}</h2>
          <p className="about-v3-text">{t('about.text')}</p>
        </motion.div>

        <motion.div
          className="about-v3-terminal"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Terminal available={t('hero.available')} />
        </motion.div>
      </div>
    </section>
  );
}
